import StickyHeader from "../components/StickyHeader";
function getAnchorFromLink(link) {
    return link.getAttribute("data-target") || link.getAttribute("href");
}
/**
 * Get target element from link URL or target ID.
 */
function getTargetFromHashLink(link) {
    const anchor = getAnchorFromLink(link);
    const el = document.getElementById(anchor.split("#")[1]);
    return el ? el : null;
}
/**
 * Scroll to specific element.
 */
export function scrollToElement(target) {
    if (!target)
        return;
    const scrollToElementEvent = new Event("to-element.restaumatic.scroll", {
        bubbles: false,
        cancelable: true,
        composed: true,
    });
    document.dispatchEvent(scrollToElementEvent);
    // Adding scrollMarginTop to target when sticky header exist
    if (StickyHeader.utils.isHeaderSticky()) {
        target.style.scrollMarginTop = `${StickyHeader.utils.getStickyHeaderHeight()}px`;
    }
    target.scrollIntoView({
        behavior: "smooth",
        block: "start",
    });
}
/**
 * Scroll to element if target is above our position (it's very likely that user expects it).
 */
export function scrollIfAbove(target) {
    if (!target)
        return;
    const offsetTop = target.getBoundingClientRect().top;
    const distanceTop = Math.round(offsetTop - StickyHeader.utils.getStickyHeaderHeight());
    if (distanceTop < 0) {
        scrollToElement(target);
    }
}
/**
 * Init scroll utility for specific anchor links.
 */
export function initScroll(anchorPrefix = "section-") {
    const anchors = document.querySelectorAll(`a[href*="#${anchorPrefix}"]`);
    anchors.forEach((item) => {
        item.addEventListener("click", (e) => {
            const link = e.currentTarget;
            const target = getTargetFromHashLink(link);
            if (!target)
                return;
            history.pushState(null, "", getAnchorFromLink(link));
            scrollToElement(target);
            e.preventDefault();
        });
    });
}
